import styled from 'styled-components';
import { Link } from 'ui/links';
import { caption, colors, spacing } from 'ui/theme';
import { EventDot } from './CalendarDay';
import { CampaignEvent } from 'modules/campaignsCalendar/hooks';
import { Badge, BADGE_VARIANTS } from 'ui/badge';
import { FlexSpacer } from 'ui/flexSpacer';

const PopoverEventLink = styled(Link)`
  color: ${colors.textPrimary};
  margin-bottom: ${spacing.half};
  text-decoration: none;

  :hover {
    text-decoration: underline;
  }
`;

const PopoverEventMeta = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  ${caption};
  color: ${colors.secondaryText};
`;

const EventBullet = styled(EventDot)`
  display: inline-block;
  margin-right: ${spacing.half};
`;

export const PopoverEvent = ({ event }: { event: CampaignEvent }) => {
  return (
    <div key={event.id}>
      <PopoverEventLink href={event.url} variant="monochrome" target="_blank">
        <EventBullet /> {event.title}
      </PopoverEventLink>
      <PopoverEventMeta>
        <Badge variant={BADGE_VARIANTS.FINISHED}> Status: {event.campaignState} </Badge>
        Send size {event.sendSize}
      </PopoverEventMeta>
    </div>
  );
};

export const PopoverEvents = ({ events }: { events?: CampaignEvent[] }) => {
  return (
    <FlexSpacer flexDirection="column" gap={spacing.plusQuarter}>
      {!!events?.length ? (
        <>
          {events.map((event) => (
            <PopoverEvent key={event.id} event={event} />
          ))}
        </>
      ) : (
        'No events for this day'
      )}
    </FlexSpacer>
  );
};
